export default "__VITE_ASSET__Dc4b1m0z__"